
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/g/unsubscribe",
      function () {
        return require("private-next-pages/g/unsubscribe.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/g/unsubscribe"])
      });
    }
  